import {Component, inject, Input, ViewChild} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

import {ModalShellComponent} from '../../../shared/modal/modal-shell/modal-shell.component';
import {StudentTicketChangeType} from "../../../models/student-ticket/change/StudentTicketChangeType";
import {ConfirmComponent} from "../../../shared/confirm/confirm.component";
import {
  StudentTicketChangeListService
} from "../../../@core/services/student-ticket/student-ticket-change-list.service";
import {StudentTicketService} from "../../../@core/services/student-ticket/student-ticket.service";
import {
  StudentTicketPaymentDataUpdateData
} from "../../../models/student-ticket/list-view/StudentTicketPaymentDataUpdateData";
import {AbstractFormModalComponent} from "../../../shared/modal/abstract-form-modal.component";
import {
  GeschwisterDetailsFormComponent,
  GeschwisterFormData
} from "../../../shared/geschwister-details-form/geschwister-details-form.component";

@Component({
  selector: 'app-geschwister-adjust-modal',
  standalone: true,
  imports: [
    ModalShellComponent,
    GeschwisterDetailsFormComponent
  ],
  templateUrl: './geschwister-adjust-modal.component.html',
  styleUrls: ['./geschwister-adjust-modal.component.scss']
})
export class GeschwisterAdjustModalComponent extends AbstractFormModalComponent {

  @Input() ticketId: string;

  private readonly studentTicketChangeListService = inject(StudentTicketChangeListService);
  private readonly modalService = inject(NgbModal);
  private readonly studentTicketService = inject(StudentTicketService);

  loading = false;

  protected validationErrorKey = 'TICKETS.GESCHWISTER.VALIDATION_ERROR';

  @ViewChild(GeschwisterDetailsFormComponent) private geschwisterForm: GeschwisterDetailsFormComponent;

  protected get form(): AbstractControl {
    return this.geschwisterForm?.form;
  }

  protected getCloseValue(): unknown {
    return this.geschwisterForm?.getFormValue();
  }

  save(): void {
    this.loading = true;
    const formValue = this.geschwisterForm.getFormValue();

    this.studentTicketChangeListService.hasTicketActiveChangeForType(this.ticketId, StudentTicketChangeType.PAYMENT_DATA)
      .subscribe({
        next: (activeChangeDto) => {
          if (activeChangeDto.hasActiveChange) {
            const modalRefActiveChange = this.modalService.open(ConfirmComponent, {size: 'md'});
            modalRefActiveChange.componentInstance.title = this.translateService.instant('TICKETS.CHANGE_LIST.ACTIVE_CHANGE_MODAL.TITLE');
            modalRefActiveChange.componentInstance.text = this.translateService.instant('TICKETS.CHANGE_LIST.ACTIVE_CHANGE_MODAL.TEXT');
            modalRefActiveChange.componentInstance.yesbuttontext = this.translateService.instant('TICKETS.CHANGE_LIST.ACTIVE_CHANGE_MODAL.YES_BUTTON');
            modalRefActiveChange.componentInstance.nobuttontext = this.translateService.instant('TICKETS.CHANGE_LIST.ACTIVE_CHANGE_MODAL.NO_BUTTON');
            modalRefActiveChange.componentInstance.onYes = () => {
              this.updateGeschwisterDetails(formValue);
            };
          } else {
            this.updateGeschwisterDetails(formValue);
          }
        },
        error: err => {
          this.customToastService.showError(this.translateService.instant('TICKETS.CHANGE_LIST.ACTIVE_CHANGE_CHECK_ERROR', { 'errorCode': err?.error?.reason }));
        }
      })
  }

  updateGeschwisterDetails(formValue: GeschwisterFormData) {
    const dto: StudentTicketPaymentDataUpdateData = {
      geschwisterkind1Id: formValue.geschwisterkind1Id,
      geschwisterkind2Id: formValue.geschwisterkind2Id,
      geschwisterkind3Id: formValue.geschwisterkind3Id,
      geschwisterkind4Id: formValue.geschwisterkind4Id,
      geschwisterkind5Id: formValue.geschwisterkind5Id,
    };
    this.studentTicketService.adjustGeschwisterData(this.ticketId, dto)
      .subscribe({
        next: () => {
          this.customToastService.showSuccess(this.translateService.instant("GESCHWISTER_DATA.SUCCESS"));
          this.activeModal.close();
        },
        error: (err) => {
          this.customToastService.showError(this.translateService.instant("GESCHWISTER_DATA.ERROR", { 'errorCode': err?.error?.reason}));
        }
      })
  }
}

